import React, { Component } from 'react';
import styled from 'styled-components';
// import { Link } from 'react-router-dom';

import AnimationContainer from '../../common/FadeAnimation';
import HeadlineWithTicker from '../../common/HeadlineWithTicker';
import Headline from '../../common/Headline';

import mediaWidth from '../../utils/mediaWidth/mediaWidth';
import Links from '../../utils/links';

const research = ['Анализ социальных медиа', 'Трендвотчинг', 'Здоровье бренда', 'Лояльность',
    'Драйверы и барьеры', 'Портрет пользователя', 'Сегментация', 'CJM', 'Service Blueprint',
    'Лучшие практики', 'Проверка гипотез', 'Пользовательские сценарии'];
const design = ['Дизайн-спринт', 'Запуск продукта', 'Новые решения', 'Дизайн-мышление',
    'ТРИЗ', 'CRAFT', 'Инновации', 'Тестирование гипотез', 'Латеральное мышление', 'Цифровой прототип',
    'Focus', 'Распределенная работа', 'Lean-подход'];
const launch = ['Концепция', 'Мокап', ' Look & Feel', 'Дизайн', 'Прототип', 'MVP', 'Agile',
    'JS', 'React', 'Node', 'Apollo', 'Express', 'Highload', 'TDD', 'Оптимизация', 'Компьютерная безопасность',
    'Разработка', 'UX/ UI', 'Итерационный подход'];

const defaultHeadlineVisible = {
    research: false,
    design: false,
    launch: false,
};

class DirectionSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            headlineVisible: defaultHeadlineVisible,
        };
        this.ref = React.createRef();
        this.onScrollShowTicker = this.onScrollShowTicker.bind(this);
    }

    componentDidMount() {
        window.addEventListener('scroll', this.onScrollShowTicker);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScrollShowTicker);
        this.ref = null;
    }

    onScrollShowTicker() {
        const { top, bottom } = this.ref.current.getBoundingClientRect();
        const { clientHeight } = document.documentElement;

        if (top < clientHeight && bottom > 0) {
            const headlineVisible = defaultHeadlineVisible;
            const middle = (bottom - top) * (2 / 3);

            if (top + middle >= clientHeight * (2 / 3)) {
                headlineVisible.research = true;
                headlineVisible.design = false;
                headlineVisible.launch = false;
            } else if (top + middle >= clientHeight * (1 / 3)) {
                headlineVisible.research = false;
                headlineVisible.design = true;
                headlineVisible.launch = false;
            } else {
                headlineVisible.research = false;
                headlineVisible.design = false;
                headlineVisible.launch = true;
            }
            this.setState({ headlineVisible });
        }
    }

    render() {
        const { headlineVisible } = this.state;
        const { className, handleChangePage } = this.props;

        return (
            <Root className={className} ref={this.ref}>
                <AnimationContainer external="parent">
                    <HeadlineStyled>
                        что мы
                        <br />
                        делаем
                    </HeadlineStyled>
                </AnimationContainer>
                <AnimationContainer external="parent" delay={150}>
                    <HeadlineWithTicker
                        onClick={() => handleChangePage(Links.RESEARCH)}
                        headline="Исследование"
                        words={research}
                        isVisibleByScroll={headlineVisible.research}
                    />
                </AnimationContainer>
                <AnimationContainer external="parent" delay={300}>
                    <HeadlineWithTicker
                        onClick={() => handleChangePage(Links.DESIGN)}
                        headline="Проектирование"
                        words={design}
                        isVisibleByScroll={headlineVisible.design}
                    />
                </AnimationContainer>
                <AnimationContainer external="parent" delay={450}>
                    <HeadlineWithTicker
                        onClick={() => handleChangePage(Links.LAUNCH)}
                        headline="Разработка"
                        words={launch}
                        isVisibleByScroll={headlineVisible.launch}
                    />
                </AnimationContainer>
            </Root>
        );
    }
}

const Root = styled.div`
    padding: 64px 0px 88px 0px;
    /* padding: 64px 0px 48px 0px; */

    background-color: #FFFFFF;

    >div:not(:nth-child(1)) :not(:nth-last-child(1)) {
        margin-bottom: 56px;
    };

    ${mediaWidth.m} {
        text-align: center;
        padding: 128px 0px 128px 0px;
    }

    ${mediaWidth.l} {
        padding: 96px 0px 96px 0px;

        >div:not(:nth-child(1)) :not(:nth-last-child(1)) {
            margin-bottom: 96px;
        };
    }
`;

const HeadlineStyled = styled(Headline)`
    max-width: 328px;
    margin-left: auto;
    margin-right: auto;

    margin-bottom: 56px;
    font-size: 32px;

    ${mediaWidth.m} {
        margin-left: initial;
        margin-right: initial;
        max-width: 100%;
        font-size: 48px;
        line-height: 48px;
    }

    ${mediaWidth.l} {
        margin-bottom: 104px;
        font-size: 64px;
        line-height: 64px;
    }
`;

export default DirectionSection;
